const roleReducer = (state = null, action) => {
    switch(action.type){
        case "SETROLE":
            return state = action.role;
        default: return state
    }
}

export default roleReducer;